import {
  SET_SHOW_PRODUCT_STATUS_MODAL,
  SET_SINGLE_PRODUCT_DELETE_ROW_ID,
  SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID,
  SET_PRODUCT_LIST_ACTIVE_TAB,
  SET_PRODUCTS_LOADING,
  SET_PRODUCTS_DATA,
  SET_PRODUCTS_ERROR,
  SET_PRODUCT_DETAIL_LOADING,
  SET_PRODUCT_DETAIL_DATA,
  SET_PRODUCT_DETAIL_ERROR,
  SET_PRODUCT_SAFETY_INFO_LOADING,
  SET_PRODUCT_SAFETY_INFO_DATA,
  SET_PRODUCT_SAFETY_INFO_ERROR,
  SET_IS_PRICE_AREA_UPDATE,
  SET_ACTIVE_INPUT_ID,
  SET_IS_PRICE_AREA_STATUS,
  SET_IS_PRICE_AREA_ERROR_MESSAGE,
  SET_SUB_TABS_BY_KEY,
  SET_PRODUCT_MODEL_CODE_LOADING,
  SET_PRODUCT_MODEL_CODE_DATA,
  SET_PRODUCT_MODEL_CODE_ERROR,
  SET_PRODUCT_ADDITIONAL_INFO_LOADING,
  SET_PRODUCT_ADDITIONAL_INFO_DATA,
  SET_PRODUCT_ADDITIONAL_INFO_ERROR,
  SET_PRODUCT_SALE_VARIANT_LOADING,
  SET_PRODUCT_SALE_VARIANT_DATA,
  SET_PRODUCT_SALE_VARIANT_ERROR,
  SET_PRODUCT_DESCRIPTION_LOADING,
  SET_PRODUCT_DESCRIPTION_DATA,
  SET_PRODUCT_DESCRIPTION_ERROR
} from "./mutation-types";

export default {
  // Product modal mutations
  [SET_SHOW_PRODUCT_STATUS_MODAL](state, payload) {
    state.showProductStatusModal = payload;
  },

  // Product row ID mutations
  [SET_SINGLE_PRODUCT_DELETE_ROW_ID](state, payload) {
    state.singleProductDeleteRowId = payload;
  },

  [SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID](state, payload) {
    state.singleProductImageUploadRowId = payload;
  },

  // Product list mutations
  [SET_PRODUCT_LIST_ACTIVE_TAB](state, payload) {
    state.productListActiveTab = payload;
  },

  // Product data mutations
  [SET_PRODUCTS_LOADING](state, { operation, isLoading }) {
    state.isLoading[operation] = isLoading;
  },

  [SET_PRODUCTS_DATA](state, payload) {
    state.productsData = payload;
  },

  [SET_PRODUCTS_ERROR](state, { operation, error }) {
    state.errors[operation] = error;
  },

  // Product detail mutations
  [SET_PRODUCT_DETAIL_LOADING](state, payload) {
    state.productDetail.loading = payload;
  },

  [SET_PRODUCT_DETAIL_DATA](state, payload) {
    state.productDetail.data = payload;
    state.productDetail.error = null;
  },

  [SET_PRODUCT_DETAIL_ERROR](state, payload) {
    state.productDetail.error = payload;
  },

  // Product safety info mutations
  [SET_PRODUCT_SAFETY_INFO_LOADING](state, payload) {
    state.productSafetyInfo.loading = payload;
  },

  [SET_PRODUCT_SAFETY_INFO_DATA](state, payload) {
    state.productSafetyInfo.data = payload;
    state.productSafetyInfo.error = null;
  },

  [SET_PRODUCT_SAFETY_INFO_ERROR](state, payload) {
    state.productSafetyInfo.error = payload;
    state.productSafetyInfo.loading = false;
  },

  // Product update mutations
  [SET_IS_PRICE_AREA_UPDATE](state, payload) {
    state.isPriceAreaUpdate = payload;
  },

  [SET_IS_PRICE_AREA_STATUS](state, payload) {
    state.isPriceAreaStatus = payload;
  },

  [SET_IS_PRICE_AREA_ERROR_MESSAGE](state, payload) {
    state.isPriceAreaErrorMessage = payload;
  },

  [SET_ACTIVE_INPUT_ID](state, id) {
    state.activePopoverId = id;
  },

  [SET_SUB_TABS_BY_KEY](state, { key, subTabs }) {
    state.subTabsByKey[key] = subTabs;
  },
  // Product model code mutations
  [SET_PRODUCT_MODEL_CODE_LOADING](state, payload) {
    state.productModelCode.loading = payload;
  },

  [SET_PRODUCT_MODEL_CODE_DATA](state, payload) {
    state.productModelCode.data = payload;
    state.productModelCode.error = null;
  },

  [SET_PRODUCT_MODEL_CODE_ERROR](state, payload) {
    state.productModelCode.error = payload;
    if (payload) {
      state.productModelCode.loading = false;
    }
  },

  // Product additional info mutations
  [SET_PRODUCT_ADDITIONAL_INFO_LOADING](state, payload) {
    state.productAdditionalInfo.loading = payload;
  },

  [SET_PRODUCT_ADDITIONAL_INFO_DATA](state, payload) {
    state.productAdditionalInfo.data = payload;
    state.productAdditionalInfo.error = null;
  },

  [SET_PRODUCT_ADDITIONAL_INFO_ERROR](state, payload) {
    state.productAdditionalInfo.error = payload;
    if (payload) {
      state.productAdditionalInfo.loading = false;
    }
  },

  [SET_PRODUCT_SALE_VARIANT_LOADING](state, payload) {
    state.productSaleVariant.loading = payload;
  },

  [SET_PRODUCT_SALE_VARIANT_DATA](state, payload) {
    state.productSaleVariant.data = payload;
    state.productSaleVariant.error = null;
  },

  [SET_PRODUCT_SALE_VARIANT_ERROR](state, payload) {
    state.productSaleVariant.error = payload;
    if (payload) {
      state.productSaleVariant.loading = false;
    }
  },

  [SET_PRODUCT_DESCRIPTION_LOADING](state, payload) {
    state.productDescription.loading = payload;
  },

  [SET_PRODUCT_DESCRIPTION_DATA](state, payload) {
    state.productDescription.data = payload;
    state.productDescription.error = null;
  },

  [SET_PRODUCT_DESCRIPTION_ERROR](state, payload) {
    state.productDescription.error = payload;
    if (payload) {
      state.productDescription.loading = false;
    }
  },
};
